
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pressArticles",
      function () {
        return require("private-next-pages/pressArticles/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pressArticles"])
      });
    }
  